import template from './public.html';
import { globals } from '@updater/angular-common';
import { getPublicUrl } from '../share-move.utils';
import { actions, selectors } from '../../../../state';
import './public.global.css';

const CDN_URL = globals.urls.cdn;

class ShareMovePublicController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, dispatch } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    dispatch(actions.share.readByCode(this.code));
  }

  $onDestroy() {
    this.disconnect();
  }

  get updaterLogoUrl() {
    return `${CDN_URL}/updater-logo.svg`;
  }

  get publicUrl() {
    return getPublicUrl(this.code);
  }
}

export const ShareMovePublicComponent = {
  template,
  controller: ShareMovePublicController,
};

function mapStateToThis(state) {
  const code = selectors.router.currentParamsProp('shareCode', state);
  const item = selectors.item.byCode(code);
  const firstName = item.userFirstName(state);

  return {
    code,
    userFirstName: firstName ? `${firstName}'s` : 'My',
    entities: selectors.current.siteConfig().brandedEntities(state),
    loading: selectors.pending.match(actions.share.isRead, state),
    item: {
      subject: item.subject(state),
      message: item.message(state),
      mainImage: item.mainImage(state),
      fromAddress: item.fromAddress(state),
      toAddress: item.toAddress(state),
    },
  };
}
